export const COMPANY_NAME = "NPR Digital Partner";

export const PREVIOUS_VERSION = "2.1.3.3";
export const CURRENT_VERSION = "2.1.3.4";
